
import "../../../Foundation/stylable/spacing.st.css.js";
import "../../../Foundation/stylable/easing.st.css.js";

import { classesRuntime, statesRuntime } from "./../../../stylable-esm-runtime.js";



var _namespace_ = "wds_1_220_2_LayoutBlocksFooter";
var _style_ = classesRuntime.bind(null, _namespace_);

export var cssStates = statesRuntime.bind(null, _namespace_);
export var style = _style_;
export var st = _style_;

export var namespace = _namespace_;
export var classes = {"root":"wds_1_220_2_LayoutBlocksFooter__root","innerContent":"wds_1_220_2_LayoutBlocksFooter__innerContent","divider":"wds_1_220_2_LayoutBlocksFooter__divider","actions":"wds_1_220_2_LayoutBlocksFooter__actions","sideActions":"wds_1_220_2_LayoutBlocksFooter__sideActions"};
export var keyframes = {}; 
export var layers = {};
export var containers = {};
export var stVars = {}; 
export var vars = {"wds-space-200":"--wds-space-200","wds-space-400":"--wds-space-400","wds-custom-modal-footer-padding-vertical":"--wds-custom-modal-footer-padding-vertical","wds-custom-modal-footer-padding-horizontal":"--wds-custom-modal-footer-padding-horizontal"}; 




